export default "__VITE_ASSET__PhDkvNE5__"